// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Burn_text-gradient__3eWeM","text":"Burn_text__313pw","input":"Burn_input__VoE_3","btns":"Burn_btns__6TG_p","button":"Burn_button__2KEJS"};